export const HC_LANGUAGES = {
    ENG: 'ENG',
    SPA: 'SPA',
};

export const HC_TEMPLATES = {
    READING: 'reading',
    ESPANOL: 'espanol',
};

export const HC_PAGES = {
    D8_TRC_PAGE: 'D8TrcPage',
    LECTURA_TRC_PAGE: 'LecturaTrcPage',
    ELM_PAGE: 'ElmPage',
    ONLINE_PAGE: 'OnlinePage',
};
